export const SUPPORT_FINANCE_EMAIL = "finance@help.costaction.com";
export const SUPPORT_EMAIL = "support@help.costaction.com";
export function getSupportUrl() {
  return `https://${window.location.host}/support`;
}